module.exports = __webpack_public_path__ + "img/bg.7206e47f.jpg";